import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["id", "name", "disabled", "value"]
const _hoisted_4 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelComponent = _resolveComponent("LabelComponent")!
  const _component_TooltipComponent = _resolveComponent("TooltipComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: "text-left Checkbox__container",
    onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hoverCheckField = true)),
    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hoverCheckField = false))
  }, [
    _createVNode(_component_LabelComponent, {
      label: _ctx.label,
      tooltip: _ctx.tooltip,
      isHtmlLabel: false,
      readonly: _ctx.disabled
    }, null, 8, ["label", "tooltip", "readonly"]),
    _createElementVNode("label", {
      class: _normalizeClass(['Checkbox', { 'align-top': _ctx.alignPostLabelToTop }]),
      for: _ctx.id,
      tabindex: "0",
      onKeyup: [
        _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.changeItem()), ["enter"])),
        _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.changeItem()), ["space"]))
      ]
    }, [
      (_ctx.tooltip)
        ? (_openBlock(), _createBlock(_component_TooltipComponent, {
            key: 0,
            type: "icon",
            class: "page-component__popover text-left dynamic-position",
            "button-class": "popover__icon popover__icon__info",
            "inner-data": _ctx.tooltip
          }, null, 8, ["inner-data"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", { innerHTML: _ctx.postLabel }, null, 8, _hoisted_2),
      _withDirectives(_createElementVNode("input", {
        id: _ctx.id,
        ref: _ctx.name + _ctx.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.change) = $event)),
        class: "Checkbox_input",
        type: "checkbox",
        name: _ctx.name,
        disabled: _ctx.disabled,
        value: _ctx.inputValue,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changed()))
      }, null, 40, _hoisted_3), [
        [_vModelCheckbox, _ctx.change]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(['Checkbox_checkmark', { 'Checkbox_checkmark_text-hover': _ctx.hoverCheckField }])
      }, null, 2)
    ], 42, _hoisted_1),
    (_ctx.showError)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          role: "alert",
          class: "Checkbox__error",
          textContent: _toDisplayString(_ctx.validationErrorText)
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 32))
}